var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Target_Layer_1",
    "data-name": "Target Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.69 233.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".target-cls-1{fill:#ff5c0f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Target") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 115.85,
    cy: 115.85,
    r: 18.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "target-cls-1",
    d: "M168.21,87V63A117.66,117.66,0,0,0,63.53,165.91H87.62A93.77,93.77,0,0,1,168.21,87Zm25.88-23.81V87.31a93.76,93.76,0,0,1,78.6,78.6h24.09A117.66,117.66,0,0,0,194.09,63.22ZM168.21,272.66a93.76,93.76,0,0,1-80.87-80.87h-24a117.63,117.63,0,0,0,104.9,104.9Zm25.88-.28v24.09A117.66,117.66,0,0,0,297,191.79H273A93.77,93.77,0,0,1,194.09,272.38Z",
    transform: "translate(-63.31 -63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "target-cls-1",
    d: "M140.46,191.79H115.75a65,65,0,0,0,50.47,50.47V217.55A41,41,0,0,1,140.46,191.79Zm-24.71-25.88h24.71a41,41,0,0,1,25.76-25.76V115.44A64.93,64.93,0,0,0,115.75,165.91Zm102.11,0h24.71a65,65,0,0,0-50.47-50.47v24.71A41,41,0,0,1,217.86,165.91ZM192.1,217.55v24.71a65,65,0,0,0,50.47-50.47H217.86A41,41,0,0,1,192.1,217.55Z",
    transform: "translate(-63.31 -63)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.a107b0a51eb6351b6631894d9918b9d4.svg";
export { ForwardRef as ReactComponent };